import { mergeDeepRight } from 'ramda'

let defaultOptions = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  credentials: 'include',
}

export default async function (url, options = {}) {
  const { baseURL = '', ...rest } = options
  return fetch(`${baseURL}${url}`, mergeDeepRight(defaultOptions, rest)).then(res => {
    if (!res.ok) throw res
    return res
  })
}
